import { createApiCall } from 'lib/base';
import { generateEndpoint } from '@ngtrvu/use-api';

const FETCH_INVESTCORE_STOCK_ACCOUNT_LIST_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_STOCK_ACCOUNT_LIST_API_ID';

const apiCall = createApiCall(
  FETCH_INVESTCORE_STOCK_ACCOUNT_LIST_API_ID,
  params => ({
    endpoint: generateEndpoint({
      host: `/api/admin/stock-accounts`,
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
